export default __webpack_public_path__ + "static/media/SlidePreview.6a25c7e1.svg";